import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-04/lesson-19/task-03";

const task: Slide = {
  titleHtml:
    "The electrical impedance of a driver with and without added mass is shown below.</br>Using the two resonance frequency values, calculate the compliance C<sub>ms</sub> of this driver</br>knowing that the added mass is equal to 5 g.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/task/task-3.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
